define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/WaWaterFacility", "../entity/WaTypeAccess", "../entity/WaFeeSchedule", "../entity/WaLandowner", "../entity/WaParcel", "../entity/WaTypeSrf", "../entity/WaTypeSpecial", "../entity/WaDoc", "../entity/WaTypeSupply", "lodash.debounce", "mobx", "../../store", "../../store/Events", "../../store/UserStore", "../../utils/StringUtil", "../domain", "../services", "../services/EventManager", "./WaApproval"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, WaWaterFacility_1, WaTypeAccess_1, WaFeeSchedule_1, WaLandowner_1, WaParcel_1, WaTypeSrf_1, WaTypeSpecial_1, WaDoc_1, WaTypeSupply_1, lodash_debounce_1, mobx_2, store_1, Events_1, UserStore_1, StringUtil_1, domain_1, services_1, EventManager_1, WaApproval_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Wa = void 0;
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    class Wa extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "RefId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicationId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicationIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AncestorId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AncestorIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ConfigId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ConfigIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemState", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemStateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AgreementType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AgreementTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovalStatus", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovalStatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovalStatusReq", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovalStatusReqError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovalStatusPrev", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovalStatusPrevError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovalStatusDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovalStatusDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovalComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovalCommentError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsFromSrwa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsFromSrwaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrSegpar", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrSegparError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ValuePerHectare", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ValuePerHectareError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "BenefitedArea", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "BenefitedAreaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsLoAddrSame", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsLoAddrSameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LoNameSearchIndex", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LoNameSearchIndexError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LoMaintenancePc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LoMaintenancePcError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TotalAreaHa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TotalAreaHaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TotalValuation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TotalValuationError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeIndexRate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeIndexRateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeAnnualNonstock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeAnnualNonstockError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeAnnualStock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeAnnualStockError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeAnnualEx", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeAnnualExError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeAnnual", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeAnnualError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeAnnualOverride", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeAnnualOverrideError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeCommentError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Lga", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgContact", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgContactError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgContactPosition", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgContactPositionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgAddress_1", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgAddress_1Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgAddress_2", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgAddress_2Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgTown", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgTownError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgState", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgStateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgPostcode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgPostcodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgPhone", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgPhoneError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgFax", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgFaxError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgEmail", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgEmailError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgMayorName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgMayorNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgCeoName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgCeoNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsCouncilDelegated", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsCouncilDelegatedError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovDelegate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovDelegateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovDelegatePosition", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovDelegatePositionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovContact", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovContactError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovContactPosition", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovContactPositionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovAddress_1", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovAddress_1Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovAddress_2", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovAddress_2Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovTown", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovTownError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovState", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovStateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovPostcode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovPostcodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovPhone", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovPhoneError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovFax", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovFaxError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovEmail", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateGovEmailError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditApprovalUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditApprovalUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditApprovalDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditApprovalDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaWaterFacility", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedWaWaterFacility", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaWaterFacilityError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaTypeAccess", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaTypeAccessError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaFeeSchedule", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedWaFeeSchedule", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaFeeScheduleError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaLandowner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedWaLandowner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaLandownerError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaParcel", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedWaParcel", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaParcelError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaTypeSrf", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaTypeSrfError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaTypeSpecial", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaTypeSpecialError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaDoc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedWaDoc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaDocError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaTypeSupply", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaTypeSupplyError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaApplication", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "waChangeEventBatchFn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UseSameAddressForLandOwners", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: true
            });
            Object.defineProperty(this, "Approval", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsSgoContactDefined", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "IsLgoContactDefined", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, Wa.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.WaApplication = parent;
            this.ApplicationId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.WaWaterFacility = [];
            this.WaTypeAccess = null;
            this.WaFeeSchedule = [];
            this.WaLandowner = [];
            this.WaParcel = [];
            this.WaTypeSrf = null;
            this.WaTypeSpecial = null;
            this.WaDoc = [];
            this.WaTypeSupply = null;
        }
        onRead(entity, parent) {
            this.WaApplication = parent;
            this.WaWaterFacility = [];
            this.WaFeeSchedule = [];
            this.WaLandowner = [];
            this.WaParcel = [];
            this.WaDoc = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.RefId = b.RefId;
            a.ApplicationId = (0, EntityUtil_1.toInt)(entity.ApplicationId);
            a.AncestorId = (0, EntityUtil_1.toInt)(entity.AncestorId);
            a.ConfigId = (0, EntityUtil_1.toInt)(entity.ConfigId);
            a.SystemState = (0, EntityUtil_1.toInt)(entity.SystemState);
            a.AgreementType = (0, EntityUtil_1.toInt)(entity.AgreementType);
            a.ApprovalStatus = b.ApprovalStatus;
            a.ApprovalStatusReq = b.ApprovalStatusReq;
            a.ApprovalStatusPrev = b.ApprovalStatusPrev;
            a.ApprovalStatusDate = b.ApprovalStatusDate;
            a.ApprovalComment = b.ApprovalComment;
            a.IsFromSrwa = (0, EntityUtil_1.toInt)(entity.IsFromSrwa);
            a.StartDt = b.StartDt;
            a.SrSegpar = (0, EntityUtil_1.toInt)(entity.SrSegpar);
            a.SrId = b.SrId;
            a.SrName = b.SrName;
            a.StockType = (0, EntityUtil_1.toInt)(entity.StockType);
            a.ValuePerHectare = (0, EntityUtil_1.toFloat)(entity.ValuePerHectare);
            a.BenefitedArea = (0, EntityUtil_1.toFloat)(entity.BenefitedArea);
            a.IsLoAddrSame = (0, EntityUtil_1.toInt)(entity.IsLoAddrSame);
            a.LoNameSearchIndex = b.LoNameSearchIndex;
            a.LoMaintenancePc = (0, EntityUtil_1.toFloat)(entity.LoMaintenancePc);
            a.TotalAreaHa = (0, EntityUtil_1.toFloat)(entity.TotalAreaHa);
            a.TotalValuation = (0, EntityUtil_1.toFloat)(entity.TotalValuation);
            a.FeeIndexRate = (0, EntityUtil_1.toFloat)(entity.FeeIndexRate);
            a.FeeAnnualNonstock = (0, EntityUtil_1.toFloat)(entity.FeeAnnualNonstock);
            a.FeeAnnualStock = (0, EntityUtil_1.toFloat)(entity.FeeAnnualStock);
            a.FeeAnnualEx = (0, EntityUtil_1.toFloat)(entity.FeeAnnualEx);
            a.FeeAnnual = (0, EntityUtil_1.toFloat)(entity.FeeAnnual);
            a.FeeAnnualOverride = (0, EntityUtil_1.toFloat)(entity.FeeAnnualOverride);
            a.FeeComment = b.FeeComment;
            a.Lga = b.Lga;
            a.LgaCode = b.LgaCode;
            a.LgContact = b.LgContact;
            a.LgContactPosition = b.LgContactPosition;
            a.LgAddress_1 = b.LgAddress_1;
            a.LgAddress_2 = b.LgAddress_2;
            a.LgTown = b.LgTown;
            a.LgState = b.LgState;
            a.LgPostcode = b.LgPostcode;
            a.LgPhone = b.LgPhone;
            a.LgFax = b.LgFax;
            a.LgEmail = b.LgEmail;
            a.LgMayorName = b.LgMayorName;
            a.LgCeoName = b.LgCeoName;
            a.IsCouncilDelegated = (0, EntityUtil_1.toInt)(entity.IsCouncilDelegated);
            a.StateGovDelegate = b.StateGovDelegate;
            a.StateGovDelegatePosition = b.StateGovDelegatePosition;
            a.StateGovContact = b.StateGovContact;
            a.StateGovContactPosition = b.StateGovContactPosition;
            a.StateGovAddress_1 = b.StateGovAddress_1;
            a.StateGovAddress_2 = b.StateGovAddress_2;
            a.StateGovTown = b.StateGovTown;
            a.StateGovState = b.StateGovState;
            a.StateGovPostcode = b.StateGovPostcode;
            a.StateGovPhone = b.StateGovPhone;
            a.StateGovFax = b.StateGovFax;
            a.StateGovEmail = b.StateGovEmail;
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditEditUser = b.AuditEditUser;
            a.AuditEditDate = b.AuditEditDate;
            a.AuditApprovalUser = b.AuditApprovalUser;
            a.AuditApprovalDate = b.AuditApprovalDate;
            a.WaWaterFacility = this.mergeArray(a.WaWaterFacility, b.WaWaterFacility, WaWaterFacility_1.WaWaterFacility);
            a.SelectedWaWaterFacility = a.SelectedWaWaterFacility && a.WaWaterFacility.find(x => x.Id == a.SelectedWaWaterFacility.Id) ? a.SelectedWaWaterFacility : null;
            a.WaTypeAccess = this.mergeObject(a.WaTypeAccess, b.WaTypeAccess, WaTypeAccess_1.WaTypeAccess);
            a.WaFeeSchedule = this.mergeArray(a.WaFeeSchedule, b.WaFeeSchedule, WaFeeSchedule_1.WaFeeSchedule);
            a.SelectedWaFeeSchedule = a.SelectedWaFeeSchedule && a.WaFeeSchedule.find(x => x.Id == a.SelectedWaFeeSchedule.Id) ? a.SelectedWaFeeSchedule : null;
            a.WaLandowner = this.mergeArray(a.WaLandowner, b.WaLandowner, WaLandowner_1.WaLandowner);
            a.SelectedWaLandowner = a.SelectedWaLandowner && a.WaLandowner.find(x => x.Id == a.SelectedWaLandowner.Id) ? a.SelectedWaLandowner : null;
            a.WaParcel = this.mergeArray(a.WaParcel, b.WaParcel, WaParcel_1.WaParcel);
            a.SelectedWaParcel = a.SelectedWaParcel && a.WaParcel.find(x => x.Id == a.SelectedWaParcel.Id) ? a.SelectedWaParcel : null;
            a.WaTypeSrf = this.mergeObject(a.WaTypeSrf, b.WaTypeSrf, WaTypeSrf_1.WaTypeSrf);
            a.WaTypeSpecial = this.mergeObject(a.WaTypeSpecial, b.WaTypeSpecial, WaTypeSpecial_1.WaTypeSpecial);
            a.WaDoc = this.mergeArray(a.WaDoc, b.WaDoc, WaDoc_1.WaDoc);
            a.SelectedWaDoc = a.SelectedWaDoc && a.WaDoc.find(x => x.Id == a.SelectedWaDoc.Id) ? a.SelectedWaDoc : null;
            a.WaTypeSupply = this.mergeObject(a.WaTypeSupply, b.WaTypeSupply, WaTypeSupply_1.WaTypeSupply);
            a.Shape = (0, EntityUtil_1.mergePolygon)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
            this.Approval && this.Approval.evaluateStatus();
        }
        onReady() {
            this.waChangeEventBatchFn = (0, lodash_debounce_1.default)(this.waChangedEventListener, 1000);
            this.WaFeeSchedule.replace(this.WaFeeSchedule.sort((a, b) => {
                if (a.StartDt == b.StartDt)
                    return 0;
                if (a.StartDt < b.StartDt)
                    return -1;
                return 1;
            }));
            this.Approval = new WaApproval_1.WaApproval(this);
            this.disableChangeObserver();
            this.resolveStakeholderInfo();
            this.enableChangeObserver();
            this.addChangeEventAction("UseSameAddressForLandOwners", this.syncLandOwnerAddresses.bind(this));
            this.addChangeEventAction("StartDt", this.waChangeEventBatchFn.bind(this));
            this.addChangeEventAction("FeeAnnualOverride", this.waChangeEventBatchFn.bind(this));
            this.addChangeEventAction("FeeAnnualEx", this.waChangeEventBatchFn.bind(this));
            this.addChangeEventAction("LoMaintenancePc", this.waChangeEventBatchFn.bind(this));
            if (this.WaTypeSrf) {
                this.WaTypeSrf.addChangeEventAction("Purpose", this.waChangeEventBatchFn.bind(this));
            }
            if (this.WaTypeSpecial) {
                this.WaTypeSpecial.addChangeEventAction("IsMaintenance", this.waChangeEventBatchFn.bind(this));
            }
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, Wa.AliasName);
            this.reset();
            if (this.AgreementType == domain_1.WaTypeDomain.Supply) {
                if (this.FeeAnnualOverride && this.FeeAnnualOverride !== 0) {
                    this.FeeAnnualOverrideError = this.FeeAnnualOverride <= this.FeeAnnualEx ? "Annual Fee must be greater than the calculated fee" : null;
                    if (this.FeeAnnualOverrideError != null) {
                        validationState.addError(this.FeeAnnualOverrideError);
                    }
                }
                else {
                    this.FeeAnnualOverrideError = null;
                }
            }
            else if (this.AgreementType == domain_1.WaTypeDomain.StockRouteFacility || this.AgreementType == domain_1.WaTypeDomain.Access) {
                if (this.FeeAnnualOverride && this.FeeAnnualOverride !== 0) {
                    this.FeeAnnualOverrideError = this.FeeAnnualOverride <= this.FeeAnnual ? "Annual Fee must be greater than the calculated fee" : null;
                    if (this.FeeAnnualOverrideError != null) {
                        validationState.addError(this.FeeAnnualOverrideError);
                    }
                }
                else {
                    this.FeeAnnualOverrideError = null;
                }
            }
            if (!this.IsMarkedForDeletion && this.IsActive && this.Approval.IsPendingApprovalOrFinalised) {
                this._validate(validationState, recurseChildren);
                this.validateReqDate(validationState, "StartDt", "Start date");
                this.validateReqString(validationState, "SrId", "A SRN Parcel");
                if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                    this.validateReqString(validationState, "StateGovDelegate", "State Officer Delegate");
                    this.validateReqString(validationState, "StateGovDelegatePosition", "State Officer Delegate Position");
                    this.validateReqString(validationState, "StateGovContact", "State Officer Contact Name");
                    this.validateReqString(validationState, "StateGovContactPosition", "State Officer Contact Position");
                    this.validateReqString(validationState, "StateGovAddress_1", "State Officer Contact Address Line 1");
                    this.validateReqString(validationState, "StateGovTown", "State Officer Contact Address Town");
                    this.validateReqString(validationState, "StateGovState", "State Officer Contact Address State");
                    this.validateReqString(validationState, "StateGovPostcode", "State Officer Contact Address Post Code");
                    this.StateGovEmailError = (this.StateGovEmail == null || !StringUtil_1.StringUtil.isEmail(this.StateGovEmail)) ? "State Officer Contact Email is required" : null;
                    if (this.StateGovEmailError != null) {
                        validationState.addError(this.StateGovEmailError);
                    }
                    this.StateGovPhoneError = this.StateGovPhone == null || !StringUtil_1.StringUtil.IsPhoneNumber(this.StateGovPhone) ? "A State Officer Contact Phone Number is required" : null;
                    if (this.StateGovPhoneError != null) {
                        validationState.addError(this.StateGovPhoneError);
                    }
                }
                if (this.LgEmail) {
                    this.LgEmailError = (this.LgEmail == null || !StringUtil_1.StringUtil.isEmail(this.LgEmail)) ? "Local Government Contact Email is required" : null;
                    if (this.LgEmailError != null) {
                        validationState.addError(this.LgEmailError);
                    }
                }
                if (this.StateGovEmail) {
                    this.StateGovEmailError = (this.StateGovEmail == null || !StringUtil_1.StringUtil.isEmail(this.StateGovEmail)) ? "State Government Contact Email is required" : null;
                    if (this.StateGovEmailError != null) {
                        validationState.addError(this.StateGovEmailError);
                    }
                }
                this.LgPhoneError = this.LgPhone == null || !StringUtil_1.StringUtil.IsPhoneNumber(this.LgPhone) ? "A valid Local Government Contact Phone Number is required" : null;
                if (this.LgPhoneError != null) {
                    validationState.addError(this.LgPhoneError);
                }
                this.StateGovPhoneError = this.StateGovPhone == null || !StringUtil_1.StringUtil.IsPhoneNumber(this.StateGovPhone) ? "A valid State Government Contact Phone Number is required" : null;
                if (this.StateGovPhoneError != null) {
                    validationState.addError(this.StateGovPhoneError);
                }
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqString(validationState, "RefId", "Reference Id");
                this.validateReqNumber(validationState, "ApplicationId", "Application Id");
                this.validateReqNumber(validationState, "AncestorId", "Ancestor Id");
                this.validateReqNumber(validationState, "ConfigId", "Configuration Id");
                this.validateReqNumber(validationState, "SystemState", "System State");
                this.validateReqNumber(validationState, "AgreementType", "AGREEMENT_TYPE");
                this.validateReqNumber(validationState, "StockType", "Predominant Stock Type");
                this.validateReqNumber(validationState, "IsLoAddrSame", "IS_LO_ADDR_SAME");
                this.validateReqString(validationState, "LgContact", "Local Government Contact Name");
                this.validateReqString(validationState, "LgContactPosition", "Local Government Contact Position");
                this.validateReqString(validationState, "LgAddress_1", "Local Government Contact Address line 1");
                this.validateReqString(validationState, "LgTown", "Local Government Contact Town");
                this.validateReqString(validationState, "LgState", "Local Government Contact State");
                this.validateReqString(validationState, "LgPostcode", "Local Government Contact Postcode");
                this.validateReqString(validationState, "LgPhone", "Local Government Contact Phone Number");
                this.validateReqString(validationState, "LgEmail", "Local Government Contact Email Address");
                this.validateReqString(validationState, "LgMayorName", "Local Government Mayor Name");
                this.validateReqString(validationState, "LgCeoName", "Local Government CEO Name");
                this.validateReqString(validationState, "AuditCreateUser", "AUDIT_CREATE_USER");
                this.validateReqDate(validationState, "AuditCreateDate", "AUDIT_CREATE_DATE");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.WaWaterFacility) {
                for (let x of this.WaWaterFacility) {
                    x.walk(func, { leading });
                }
            }
            if (this.WaTypeAccess) {
                this.WaTypeAccess.walk(func, { leading });
            }
            if (this.WaFeeSchedule) {
                for (let x of this.WaFeeSchedule) {
                    x.walk(func, { leading });
                }
            }
            if (this.WaLandowner) {
                for (let x of this.WaLandowner) {
                    x.walk(func, { leading });
                }
            }
            if (this.WaParcel) {
                for (let x of this.WaParcel) {
                    x.walk(func, { leading });
                }
            }
            if (this.WaTypeSrf) {
                this.WaTypeSrf.walk(func, { leading });
            }
            if (this.WaTypeSpecial) {
                this.WaTypeSpecial.walk(func, { leading });
            }
            if (this.WaDoc) {
                for (let x of this.WaDoc) {
                    x.walk(func, { leading });
                }
            }
            if (this.WaTypeSupply) {
                this.WaTypeSupply.walk(func, { leading });
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                RefId: this.RefId,
                ApplicationId: this.ApplicationId,
                AncestorId: this.AncestorId,
                ConfigId: this.ConfigId,
                SystemState: this.SystemState,
                AgreementType: this.AgreementType,
                ApprovalStatus: this.ApprovalStatus,
                ApprovalStatusReq: this.ApprovalStatusReq,
                ApprovalStatusPrev: this.ApprovalStatusPrev,
                ApprovalStatusDate: this.ApprovalStatusDate,
                ApprovalComment: this.ApprovalComment,
                IsFromSrwa: this.IsFromSrwa,
                StartDt: this.StartDt,
                SrSegpar: this.SrSegpar,
                SrId: this.SrId,
                SrName: this.SrName,
                StockType: this.StockType,
                ValuePerHectare: this.ValuePerHectare,
                BenefitedArea: this.BenefitedArea,
                IsLoAddrSame: this.IsLoAddrSame,
                LoNameSearchIndex: this.LoNameSearchIndex,
                LoMaintenancePc: this.LoMaintenancePc,
                TotalAreaHa: this.TotalAreaHa,
                TotalValuation: this.TotalValuation,
                FeeIndexRate: this.FeeIndexRate,
                FeeAnnualNonstock: this.FeeAnnualNonstock,
                FeeAnnualStock: this.FeeAnnualStock,
                FeeAnnualEx: this.FeeAnnualEx,
                FeeAnnual: this.FeeAnnual,
                FeeAnnualOverride: this.FeeAnnualOverride,
                FeeComment: this.FeeComment,
                Lga: this.Lga,
                LgaCode: this.LgaCode,
                LgContact: this.LgContact,
                LgContactPosition: this.LgContactPosition,
                LgAddress_1: this.LgAddress_1,
                LgAddress_2: this.LgAddress_2,
                LgTown: this.LgTown,
                LgState: this.LgState,
                LgPostcode: this.LgPostcode,
                LgPhone: this.LgPhone,
                LgFax: this.LgFax,
                LgEmail: this.LgEmail,
                LgMayorName: this.LgMayorName,
                LgCeoName: this.LgCeoName,
                IsCouncilDelegated: this.IsCouncilDelegated,
                StateGovDelegate: this.StateGovDelegate,
                StateGovDelegatePosition: this.StateGovDelegatePosition,
                StateGovContact: this.StateGovContact,
                StateGovContactPosition: this.StateGovContactPosition,
                StateGovAddress_1: this.StateGovAddress_1,
                StateGovAddress_2: this.StateGovAddress_2,
                StateGovTown: this.StateGovTown,
                StateGovState: this.StateGovState,
                StateGovPostcode: this.StateGovPostcode,
                StateGovPhone: this.StateGovPhone,
                StateGovFax: this.StateGovFax,
                StateGovEmail: this.StateGovEmail,
                AuditCreateUser: this.AuditCreateUser,
                AuditCreateDate: this.AuditCreateDate,
                AuditEditUser: this.AuditEditUser,
                AuditEditDate: this.AuditEditDate,
                AuditApprovalUser: this.AuditApprovalUser,
                AuditApprovalDate: this.AuditApprovalDate,
                WaWaterFacility: this.WaWaterFacility.map(x => x.toJson()),
                WaTypeAccess: this.WaTypeAccess ? this.WaTypeAccess.toJson() : undefined,
                WaFeeSchedule: this.WaFeeSchedule.map(x => x.toJson()),
                WaLandowner: this.WaLandowner.map(x => x.toJson()),
                WaParcel: this.WaParcel.map(x => x.toJson()),
                WaTypeSrf: this.WaTypeSrf ? this.WaTypeSrf.toJson() : undefined,
                WaTypeSpecial: this.WaTypeSpecial ? this.WaTypeSpecial.toJson() : undefined,
                WaDoc: this.WaDoc.map(x => x.toJson()),
                WaTypeSupply: this.WaTypeSupply ? this.WaTypeSupply.toJson() : undefined,
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get StatusValue() {
            var _a;
            let k = this.ApprovalStatusReq ? this.ApprovalStatusReq : this.ApprovalStatus;
            let v = (_a = domain_1.WaStatusDomain.findByKey(k)) === null || _a === void 0 ? void 0 : _a.value;
            return this.ApprovalStatusReq ? `${v}*` : v;
        }
        get IsUserPriviledgedToEdit() {
            return this.SecurityAccessLevel == EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        get IsAmendmentModeActive() {
            return this.ApprovalStatus != domain_1.WaStatusDomain.Draft ? true : false;
        }
        get IsReadOnly() {
            return !this.IsUserPriviledgedToEdit || this.SystemState == domain_1.WaSysStatusDomain.Archived || this.IsAmendmentModeActive;
        }
        get IsActive() {
            return this.SystemState == domain_1.WaSysStatusDomain.Active;
        }
        get StateWaterFacilities() {
            return this.WaWaterFacility.filter(f => f.OwnerType == domain_1.FacilityOwnerDomain.StateOwned || f.OwnerType == domain_1.FacilityOwnerDomain.CouncilOwned);
        }
        get StateWaterFacility() {
            return this.WaWaterFacility.find(f => f.OwnerType == domain_1.FacilityOwnerDomain.StateOwned || f.OwnerType == domain_1.FacilityOwnerDomain.CouncilOwned);
        }
        get LoWaterFacilities() {
            return this.WaWaterFacility.filter(f => f.OwnerType == domain_1.FacilityOwnerDomain.PrivatelyOwned);
        }
        get SrnParcels() {
            return this.WaParcel.filter(f => f.ParcelType == domain_1.WaParcelTypeDomain.SrnParcel);
        }
        get LoParcels() {
            return this.WaParcel.filter(f => f.ParcelType == domain_1.WaParcelTypeDomain.LandownerParcel);
        }
        updateWaterAgreementOnGeometryChange() {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Updating Water Agreement");
                services_1.SrmsServiceManager.Instance.WaterAgreementApplication.updateWaterAgreementOnGeometryChange(this.toJson()).then(res => {
                    res && res.Wa && this.merge(res.Wa);
                    resolve();
                }).catch(err => {
                    reject(err);
                });
            });
        }
        updateWaterAgreementOnWaterFacilityReselection(wfId) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Updating Water Agreement");
                services_1.SrmsServiceManager.Instance.WaterAgreementApplication.updateWaterAgreementOnWaterFacilityReselection(this.toJson(), wfId).then(wa => {
                    wa && this.merge(wa);
                    resolve();
                }).catch(err => {
                    reject(err);
                });
            });
        }
        syncLandOwnerAddresses() {
            if (this.WaLandowner.length > 0 && this.UseSameAddressForLandOwners) {
                let from = this.SelectedWaLandowner || this.WaLandowner[0];
                for (let lo of this.WaLandowner) {
                    if (lo !== from) {
                        lo.PostalAddress_1 = from.PostalAddress_1;
                        lo.PostalAddress_2 = from.PostalAddress_2;
                        lo.Town = from.Town;
                        lo.State = from.State;
                        lo.Postcode = from.Postcode;
                    }
                }
            }
        }
        resolveStakeholderInfo() {
            if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                if (this.StateGovContact && this.StateGovContact.trim().length > 0) {
                    this.IsSgoContactDefined = true;
                }
                if (!this.IsSgoContactDefined) {
                    (0, EventManager_1.notify)("Auto-populating SGO Information");
                    try {
                        const user = store_1.StoreManager.Instance.userStore.User;
                        (0, mobx_2.runInAction)(() => {
                            this.StateGovContact = user.userData.FirstName + " " + user.userData.LastName;
                            this.StateGovPhone = user.userData.Phone;
                            this.StateGovEmail = user.userData.Email;
                            this.StateGovFax = user.userData.Fax;
                            this.StateGovAddress_1 = user.userData.Address;
                            this.StateGovAddress_2 = user.userData.Address2;
                            this.StateGovTown = user.userData.City;
                            this.StateGovState = user.userData.State;
                            this.StateGovPostcode = user.userData.PostCode;
                            this.IsSgoContactDefined = true;
                        });
                    }
                    catch (err) {
                        console.error(err);
                    }
                }
            }
            else {
                if (this.LgContact && this.LgContact.trim().length > 0) {
                    this.IsLgoContactDefined = true;
                }
                if (!this.IsLgoContactDefined) {
                    (0, EventManager_1.notify)("Auto-populating LGO Information");
                    try {
                        const user = store_1.StoreManager.Instance.userStore.User;
                        (0, mobx_2.runInAction)(() => {
                            this.LgContact = user.userData.FirstName + " " + user.userData.LastName;
                            this.LgPhone = user.userData.Phone;
                            this.LgEmail = user.userData.Email;
                            this.LgFax = user.userData.Fax;
                            this.LgAddress_1 = user.userData.Address;
                            this.LgAddress_2 = user.userData.Address2;
                            this.LgTown = user.userData.City;
                            this.LgState = user.userData.State;
                            this.LgPostcode = user.userData.PostCode;
                            this.IsLgoContactDefined = true;
                        });
                    }
                    catch (err) {
                        console.error(err);
                    }
                }
            }
        }
        get ApplicableDocumentTypes() {
            return domain_1.DynamicDomain.createFromArray(services_1.AppConfigManager.InstanceSync.getDocumentTypesByWaterAgreement(this), "DocType", "DocTypeDesc");
        }
        waChangedEventListener(change) {
            if (this.ApprovalStatus == domain_1.WaStatusDomain.Finalised) {
                console.error("Updating a finalised WA");
            }
            this.disableChangeObserver();
            this.calculateProperties(change);
            let validation = this.validate(true);
            if (validation.HasMessages) {
                services_1.EventManager.Instance.emit(Events_1.VALIDATION_UPDATE_EVENT, validation);
            }
            if (change.name == "IsMaintenance") {
                this.LoMaintenancePc = 0;
            }
            this.enableChangeObserver();
        }
        calculateProperties(change) {
            if (["FeeAnnualOverride", "FeeAnnualEx", "LoMaintenancePc", "Purpose"].indexOf(change.name.toString()) > -1) {
                this.calculateWaFees();
            }
            else if (change.name == "StartDt") {
                this.calculateWaDates();
            }
        }
        calculateWaDates() {
            (0, EventManager_1.notify)("Calculating Dates");
            services_1.SrmsServiceManager.Instance.WaterAgreementApplication.updateWaterAgreementOnDateChange(this.toJson()).then((wa) => {
                (0, mobx_2.runInAction)(() => {
                    wa && this.merge(wa);
                });
            });
        }
        calculateWaFees() {
            (0, EventManager_1.notify)("Calculating Fees");
            services_1.SrmsServiceManager.Instance.WaterAgreementApplication.calculateWaterAgreementFees(this.toJson()).then((fee) => {
                if (fee) {
                    (0, mobx_2.runInAction)(() => {
                        this.FeeIndexRate = fee.FeeIndexRate;
                        this.ValuePerHectare = fee.ValuePerHectare;
                        this.FeeAnnualNonstock = fee.FeeAnnualNonstock;
                        this.FeeAnnualStock = fee.FeeAnnualStock;
                        this.FeeAnnual = fee.FeeAnnual;
                        this.FeeAnnualEx = fee.FeeAnnualEx;
                        let feeSchedule = this.WaFeeSchedule.find(x => x.Id == fee.FeeSchedule.Id);
                        if (feeSchedule) {
                            feeSchedule.Fee = fee.FeeSchedule.Fee;
                            feeSchedule.FeeEx = fee.FeeSchedule.FeeEx;
                        }
                    });
                }
            });
        }
    }
    exports.Wa = Wa;
    Object.defineProperty(Wa, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Wa"
    });
    Object.defineProperty(Wa, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Water Agreement"
    });
    Object.defineProperty(Wa, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "RefId", "ApplicationId", "AncestorId", "ConfigId", "SystemState", "AgreementType", "ApprovalStatus", "ApprovalStatusReq", "ApprovalStatusPrev", "ApprovalStatusDate", "ApprovalComment", "IsFromSrwa", "StartDt", "SrSegpar", "SrId", "SrName", "StockType", "ValuePerHectare", "BenefitedArea", "IsLoAddrSame", "LoNameSearchIndex", "LoMaintenancePc", "TotalAreaHa", "TotalValuation", "FeeIndexRate", "FeeAnnualNonstock", "FeeAnnualStock", "FeeAnnualEx", "FeeAnnual", "FeeAnnualOverride", "FeeComment", "Lga", "LgaCode", "LgContact", "LgContactPosition", "LgAddress_1", "LgAddress_2", "LgTown", "LgState", "LgPostcode", "LgPhone", "LgFax", "LgEmail", "LgMayorName", "LgCeoName", "IsCouncilDelegated", "StateGovDelegate", "StateGovDelegatePosition", "StateGovContact", "StateGovContactPosition", "StateGovAddress_1", "StateGovAddress_2", "StateGovTown", "StateGovState", "StateGovPostcode", "StateGovPhone", "StateGovFax", "StateGovEmail", "AuditCreateUser", "AuditCreateDate", "AuditEditUser", "AuditEditDate", "AuditApprovalUser", "AuditApprovalDate", "Shape"]
    });
    Object.defineProperty(Wa, "RefIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 50
    });
    Object.defineProperty(Wa, "RefIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "ApplicationIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "AncestorIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "ConfigIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "SystemStateDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "SystemStateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "AgreementTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "AgreementTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "ApprovalStatusLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(Wa, "ApprovalStatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "ApprovalStatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "ApprovalStatusReqLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(Wa, "ApprovalStatusReqDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "ApprovalStatusReqReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "ApprovalStatusPrevLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(Wa, "ApprovalStatusPrevDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "ApprovalStatusPrevReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "ApprovalStatusDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "ApprovalCommentLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1024
    });
    Object.defineProperty(Wa, "ApprovalCommentTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter any supporting information relevant to the approval decision"
    });
    Object.defineProperty(Wa, "ApprovalCommentReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "IsFromSrwaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StartDtTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "The expected start date of the agreement"
    });
    Object.defineProperty(Wa, "StartDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "SrSegparReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "SrIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 30
    });
    Object.defineProperty(Wa, "SrIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "SrNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 40
    });
    Object.defineProperty(Wa, "SrNameTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Stock Route Name (if known)"
    });
    Object.defineProperty(Wa, "SrNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StockTypeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What is the predominant stock on the property?"
    });
    Object.defineProperty(Wa, "StockTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "StockTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "ValuePerHectareReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "BenefitedAreaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "IsLoAddrSameTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Do all landowners have the same address details?"
    });
    Object.defineProperty(Wa, "IsLoAddrSameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "LoNameSearchIndexLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 200
    });
    Object.defineProperty(Wa, "LoNameSearchIndexReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "LoMaintenancePcTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Percentage of Maintenance Performed by Landowner"
    });
    Object.defineProperty(Wa, "LoMaintenancePcReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "TotalAreaHaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "TotalValuationReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "FeeIndexRateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "FeeAnnualNonstockReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "FeeAnnualStockReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "FeeAnnualExReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "FeeAnnualReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "FeeAnnualOverrideTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "If you wish to override the calculated fee with a higher fee, enter that amount here. If you do not enter anything, or leave the amount as $0, the calculated fee will take effect"
    });
    Object.defineProperty(Wa, "FeeAnnualOverrideReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "FeeCommentLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Wa, "FeeCommentTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter a justification for any fee variation here"
    });
    Object.defineProperty(Wa, "FeeCommentReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "LgaLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 128
    });
    Object.defineProperty(Wa, "LgaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "LgaCodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(Wa, "LgaCodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "LgContactLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(Wa, "LgContactReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "LgContactPositionLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(Wa, "LgContactPositionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "LgAddress_1Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Wa, "LgAddress_1Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "LgAddress_2Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Wa, "LgAddress_2Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "LgTownLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 40
    });
    Object.defineProperty(Wa, "LgTownReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "LgStateLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(Wa, "LgStateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "LgPostcodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(Wa, "LgPostcodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "LgPhoneLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 14
    });
    Object.defineProperty(Wa, "LgPhoneReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "LgFaxLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 14
    });
    Object.defineProperty(Wa, "LgFaxReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "LgEmailLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(Wa, "LgEmailReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "LgMayorNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(Wa, "LgMayorNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "LgCeoNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(Wa, "LgCeoNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "IsCouncilDelegatedTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Has the council delegated their powers to the Chief Executive Officer?"
    });
    Object.defineProperty(Wa, "IsCouncilDelegatedReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StateGovDelegateLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(Wa, "StateGovDelegateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StateGovDelegatePositionLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(Wa, "StateGovDelegatePositionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StateGovContactLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(Wa, "StateGovContactReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StateGovContactPositionLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(Wa, "StateGovContactPositionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StateGovAddress_1Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Wa, "StateGovAddress_1Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StateGovAddress_2Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Wa, "StateGovAddress_2Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StateGovTownLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 40
    });
    Object.defineProperty(Wa, "StateGovTownReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StateGovStateLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(Wa, "StateGovStateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StateGovPostcodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(Wa, "StateGovPostcodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StateGovPhoneLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 14
    });
    Object.defineProperty(Wa, "StateGovPhoneReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StateGovFaxLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 14
    });
    Object.defineProperty(Wa, "StateGovFaxReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "StateGovEmailLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(Wa, "StateGovEmailReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Wa, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Wa, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Wa, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "AuditApprovalUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Wa, "AuditApprovalUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Wa, "AuditApprovalDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "RefId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "RefIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ApplicationId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ApplicationIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AncestorId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AncestorIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ConfigId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ConfigIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "SystemState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "SystemStateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AgreementType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AgreementTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ApprovalStatus", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ApprovalStatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ApprovalStatusReq", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ApprovalStatusReqError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ApprovalStatusPrev", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ApprovalStatusPrevError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ApprovalStatusDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ApprovalStatusDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ApprovalComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ApprovalCommentError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "IsFromSrwa", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "IsFromSrwaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StartDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StartDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "SrSegpar", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "SrSegparError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "SrId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "SrIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "SrName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "SrNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StockType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StockTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ValuePerHectare", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "ValuePerHectareError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "BenefitedArea", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "BenefitedAreaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "IsLoAddrSame", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "IsLoAddrSameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LoNameSearchIndex", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LoNameSearchIndexError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LoMaintenancePc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LoMaintenancePcError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "TotalAreaHa", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "TotalAreaHaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "TotalValuation", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "TotalValuationError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeIndexRate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeIndexRateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeAnnualNonstock", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeAnnualNonstockError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeAnnualStock", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeAnnualStockError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeAnnualEx", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeAnnualExError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeAnnual", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeAnnualError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeAnnualOverride", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeAnnualOverrideError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "FeeCommentError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "Lga", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgaCode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgaCodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgContact", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgContactError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgContactPosition", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgContactPositionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgAddress_1", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgAddress_1Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgAddress_2", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgAddress_2Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgTown", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgTownError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgStateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgPostcode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgPostcodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgPhone", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgPhoneError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgFax", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgFaxError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgEmail", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgEmailError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgMayorName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgMayorNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgCeoName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "LgCeoNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "IsCouncilDelegated", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "IsCouncilDelegatedError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovDelegate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovDelegateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovDelegatePosition", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovDelegatePositionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovContact", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovContactError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovContactPosition", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovContactPositionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovAddress_1", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovAddress_1Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovAddress_2", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovAddress_2Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovTown", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovTownError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovStateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovPostcode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovPostcodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovPhone", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovPhoneError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovFax", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovFaxError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovEmail", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "StateGovEmailError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AuditApprovalUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AuditApprovalUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AuditApprovalDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "AuditApprovalDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaWaterFacility", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "SelectedWaWaterFacility", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaWaterFacilityError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaTypeAccess", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaTypeAccessError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaFeeSchedule", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "SelectedWaFeeSchedule", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaFeeScheduleError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaLandowner", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "SelectedWaLandowner", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaLandownerError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaParcel", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "SelectedWaParcel", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaParcelError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaTypeSrf", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaTypeSrfError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaTypeSpecial", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaTypeSpecialError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaDoc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "SelectedWaDoc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaDocError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaTypeSupply", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaTypeSupplyError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "WaApplication", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], Wa.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Wa.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Wa.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "UseSameAddressForLandOwners", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "Approval", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], Wa.prototype, "StatusValue", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Wa.prototype, "IsUserPriviledgedToEdit", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Wa.prototype, "IsAmendmentModeActive", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Wa.prototype, "IsReadOnly", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Wa.prototype, "IsActive", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Wa.prototype, "StateWaterFacilities", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Wa.prototype, "StateWaterFacility", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Wa.prototype, "LoWaterFacilities", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Wa.prototype, "SrnParcels", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Wa.prototype, "LoParcels", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Wa.prototype, "syncLandOwnerAddresses", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "IsSgoContactDefined", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Wa.prototype, "IsLgoContactDefined", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], Wa.prototype, "ApplicableDocumentTypes", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Wa.prototype, "waChangedEventListener", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Wa.prototype, "calculateWaDates", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Wa.prototype, "calculateWaFees", null);
});
